import React from 'react';
import { ThumbnailImageProps } from '../ThumbnailImage/ThumbnailImage';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { StackedThumbnailImage } from '../ThumbnailImage/StackedThumbnailImage';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { CarouselProps } from '@jbhi-fi/lanyard-ui/components/Carousel/Carousel';

export type ThumbnailImageCarouselProps = {
  thumbnails: Array<ThumbnailImageProps>;
  isStacked?: boolean;
  carouselProps?: Partial<CarouselProps>;
};

export const ThumbnailImageCarousel = ({
  thumbnails,
  isStacked = false,
  carouselProps = {},
}: ThumbnailImageCarouselProps) => {
  const groupedThumbnails = thumbnails.reduce((acc, thumbnailProps, i) => {
    if (i % 2 === 0) {
      acc.push([thumbnailProps]);
    } else {
      acc[acc.length - 1].push(thumbnailProps);
    }
    return acc;
  }, [] as Array<Array<ThumbnailImageProps>>);

  const isDesktop = useBreakpoint('md', 'up');

  return (
    <Carousel
      slidesPerView="auto"
      showPagination={false}
      showArrows={isDesktop}
      spaceBetween={0}
      slidesOffsetBefore={-8}
      slidesPerGroup={isDesktop ? 2 : 1}
      fullBleed={!isDesktop}
      arrowPosition="bottom"
      {...carouselProps}
    >
      {groupedThumbnails.map((thumbnails, i) => (
        <StackedThumbnailImage key={i} thumbnails={thumbnails} isStacked={!isDesktop && isStacked} />
      ))}
    </Carousel>
  );
};
